import { Container, Typography } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';
import { PrivacyPolicy as PrivacyPolicyContent } from '../components/legalDocuments';

export const Route = createFileRoute('/privacy-policy')({
  component: PrivacyPolicy,
});

function PrivacyPolicy() {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography
        variant="h3"
        component="h1"
        gutterBottom
        data-testid="privacy-policy-page-title"
      >
        Privacy Policy
      </Typography>
      <PrivacyPolicyContent />
    </Container>
  );
}
